(function () {

    'use strict';

    angular.module('asys')
        .component('asysBlockFahrzeughalter', {
            require: {
                form: '^form'
            },
            bindings: {
                fahrzeughalter: '<abfFahrzeughalter'
            },
            templateUrl: 'bloecke/kfz/fahrzeughalter/blockFahrzeughalter.html',
            controller: FahrzeughalterController,
            controllerAs: 'fahrzeughalterVm'
        });

    FahrzeughalterController.$inject = [
        'lodash',
        'AppConfig',
        'AngebotModel',
        'BasisAngebotService',
        'MiscUtilsService',
        'SchluesselWerteUtilsService'
    ];
    function FahrzeughalterController(_, AppConfig, AngebotModel, BasisAngebotService, MiscUtilsService, SchluesselWerteUtilsService) {
        var vm = this,
            formFieldNames = [
                'rechtsform',
                'anrede',
                'vorname',
                'nachname',
                'name2',
                'strasse',
                'postleitzahl',
                'ort'
            ];

        vm.$onInit = onInit;

        vm.isPostleitzahlDisabled = isPostleitzahlDisabled;
        vm.isAdresseDisabled = isAdresseDisabled;
        vm.isArbeitgeberBerufDisabled = isArbeitgeberBerufDisabled;
        vm.isAnredeErlaubt = isAnredeErlaubt;
        vm.isArbeitergeberBerufErlaubt = isArbeitergeberBerufErlaubt;
        vm.isLinkFahrzeughalterAenderErlaubt = isLinkFahrzeughalterAenderErlaubt;
        vm.onFahrzeughalterAendern = onFahrzeughalterAendern;
        vm.isRechtsformErlaubt = isRechtsformErlaubt;
        vm.onChangeRechtsform = onChangeRechtsform;
        vm.onChangeAnrede = onChangeAnrede;

        function activate() {
            vm.angebotModel = AngebotModel.get();

            vm.options = vm.options || {};
            vm.uuid = MiscUtilsService.guid('#');
            vm.model = {};

            vm.blockArbeitgeberBerufOptions = {
                labelArbeitsverhaeltnis: 'Ist der Fahrzeughalter Rentner oder Pensionär? Dann geben Sie bitte das letzte Beschäftigungsverhältnis an.',
                labelBevorzugterArbeitgeber: 'Ist der Fahrzeughalter bei einem dieser Arbeitgeber angesetellt?',
                labelTaetigkeitsschluessel: 'Der Fahrzeughalter ist Beamter',
                labelBevorzugterBerufszweig: 'Ist der Fahrzeughalter in einem dieser Berufsfelder selbstständig?',
                labelIngenieur: 'Der Fahrzeughalter ist Ingenieur',
                labelBlaulicht: 'Der Fahrzeughalter ist ehrenamtlich tätig bei einer Blaulichtorganisation'
            };

            vm.formFieldNames = _.zipObject(formFieldNames, _.map(formFieldNames, function (fieldName) {
                return [
                    fieldName,
                    vm.uuid
                ].join('_');
            }));

            if (!isArbeitergeberBerufErlaubt() && BasisAngebotService.isAngebotAenderbar(vm.angebotModel.angebot, 'ANTRAG')) {
                _.set(vm.fahrzeughalter, 'arbeitgeber', null);
                _.set(vm.fahrzeughalter, 'beruf', null);
            }
            vm.isInReadOnlyMode = (
                !!_.get(vm.fahrzeughalter, 'partnernummer') ||
                _.get(vm.angebotModel.angebot, 'aenderbareTarifmerkmale.fahrzeughalterdaten') === false
            );

            if (!vm.isInReadOnlyMode && !isRechtsformErlaubt()) {
                if (vm.isPrivatPerson) {
                    vm.model.rechtsform = 'NP';
                } else if (!vm.isPrivatPerson) {
                    if (_.includes(['1', '3'], _.get(vm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.fahrzeughaltereigenschaft.wert'))) {
                        vm.model.rechtsform = 'NP';

                    } else {
                        vm.model.rechtsform = 'JP';
                    }
                }
            }

            if (_.get(vm.fahrzeughalter, 'mitgliedsart.wert')) {
                vm.model.rechtsform = BasisAngebotService.isPrivatPerson(vm.angebotModel.angebot, vm.fahrzeughalter) ? 'NP' : 'JP';
            }

            setFilteredAnrede();

            vm.model.anrede = _.get(vm.fahrzeughalter, 'anrede');

            vm.isPrivatPerson = BasisAngebotService.isPrivatPerson(vm.angebotModel.angebot);
            vm.isRechtsformNatuerlichePerson = getIsRechtsformNatuerlichePerson();
            if (!vm.isInReadOnlyMode && !isAnredeErlaubt()) {
                vm.model.anrede = _.find(SchluesselWerteUtilsService.getSchluesselwert('anreden'), { wert: '3' });
                vm.model.rechtsform = 'JP';
                _.set(vm.fahrzeughalter, 'mitgliedsart', BasisAngebotService.getConstant('mitgliedsarten').firmenkunde);
                _.set(vm.fahrzeughalter, 'anrede', vm.model.anrede);
            }
        }
        function onInit() {
            activate();
        }

        function getIsRechtsformNatuerlichePerson() {
            return (
                BasisAngebotService.isPrivatPerson(vm.angebotModel.angebot, vm.fahrzeughalter) &&
                (
                    (
                        BasisAngebotService.isPrivatPerson(vm.angebotModel.angebot)
                    ) || (
                        !BasisAngebotService.isPrivatPerson(vm.angebotModel.angebot) &&
                        _.get(vm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.fahrzeughaltereigenschaft.wert') !== '2' // Autohaus/Kaufpreisrabatt
                    )
                )
            );
        }
        function isPostleitzahlDisabled() {
            return MiscUtilsService.isNotEmpty(_.get(vm.fahrzeughalter, 'postleitzahl'));
        }

        function isAdresseDisabled() {
            return (
                vm.isInReadOnlyMode &&
                (
                    MiscUtilsService.isEverythingNotEmpty(_.get(vm.fahrzeughalter, 'strasse'), _.get(vm.fahrzeughalter, 'postleitzahl'), _.get(vm.fahrzeughalter, 'ort'))
                )
            );
        }

        function isArbeitgeberBerufDisabled() {
            return (
                vm.isInReadOnlyMode &&
                MiscUtilsService.isNotEmpty(_.get(vm.angebotModel.angebotOriginal, 'angebotsgegenstandFahrzeug.fahrzeughalter.arbeitgeber')) &&
                MiscUtilsService.isNotEmpty(_.get(vm.angebotModel.angebotOriginal, 'angebotsgegenstandFahrzeug.fahrzeughalter.beruf'))
            );
        }

        function isAnredeErlaubt() {
            return (
                vm.isRechtsformNatuerlichePerson === true
            );
        }
        function isArbeitergeberBerufErlaubt() {
            var mitgliedsart = _.get(vm.fahrzeughalter, 'mitgliedsart.wert');

            return (
                (
                    MiscUtilsService.isEmpty(mitgliedsart) ||
                    _.includes(AppConfig.ANGEBOT.mgaPrivat, mitgliedsart)
                ) && (
                    vm.model.rechtsform !== 'JP'
                )
            );
        }

        function isLinkFahrzeughalterAenderErlaubt() {
            return (
                !!_.get(vm.fahrzeughalter, 'partnernummer') &&
                _.get(vm.angebotModel.angebot, 'aenderbareTarifmerkmale.fahrzeughalterdaten') !== false &&
                BasisAngebotService.isAngebotAenderbar(vm.angebotModel.angebot, 'ANTRAG')
            );
        }

        function onFahrzeughalterAendern() {
            vm.origFahrzeughalter = _.cloneDeep(vm.fahrzeughalter);

            _.keys(vm.fahrzeughalter).forEach(function (key) {
                vm.fahrzeughalter[key] = null;
            });

            vm.fahrzeughalter.postleitzahl = _.get(vm.origFahrzeughalter, 'postleitzahl');
            vm.fahrzeughalter.ort = _.get(vm.origFahrzeughalter, 'ort');
            vm.fahrzeughalter.mitgliedsart = _.get(vm.origFahrzeughalter, 'mitgliedsart');

            activate();
        }

        function isRechtsformErlaubt() {
            if (vm.isPrivatPerson) {
                return _.includes(['2', '4'],_.get(vm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.fahrzeughaltereigenschaft.wert'));
            } else if (!vm.isPrivatPerson) {
                return _.includes(['4'], _.get(vm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.fahrzeughaltereigenschaft.wert'));
            }
        }

        function onChangeRechtsform(rechtsform) {
            if (rechtsform === 'NP') {
                vm.model.anrede = null;

                _.set(vm.fahrzeughalter, 'anrede', null);
                _.set(vm.fahrzeughalter, 'mitgliedsart', BasisAngebotService.getConstant('mitgliedsarten').privatkunde);
                _.set(vm.fahrzeughalter, 'nachname', null);
                _.set(vm.fahrzeughalter, 'name2', null);
                _.set(vm.fahrzeughalter, 'taetigkeitsschluessel', null);
            } else if (rechtsform === 'JP') {
                vm.model.anrede = _.find(SchluesselWerteUtilsService.getSchluesselwert('anreden'), { wert: '3' });

                _.set(vm.fahrzeughalter, 'anrede', vm.model.anrede);
                _.set(vm.fahrzeughalter, 'mitgliedsart', BasisAngebotService.getConstant('mitgliedsarten').firmenkunde);
                _.set(vm.fahrzeughalter, 'vorname', null);
                _.set(vm.fahrzeughalter, 'nachname', null);
                _.set(vm.fahrzeughalter, 'arbeitgeber', null);
                _.set(vm.fahrzeughalter, 'beruf', null);
                _.set(vm.fahrzeughalter, 'blaulicht', null);
                _.set(vm.fahrzeughalter, 'geburtsdatum', null);
                _.set(vm.fahrzeughalter, 'taetigkeitsschluessel', _.find(BasisAngebotService.getConstant('taetigkeitsschluessel'), ['wert', '0']));
                _.set(vm.angebotModel.formData, 'fahrzeughalter', null);
            }

            vm.isRechtsformNatuerlichePerson = getIsRechtsformNatuerlichePerson();
            setFilteredAnrede();
        }

        function onChangeAnrede(anrede) {
            _.set(vm.fahrzeughalter, 'anrede', anrede);
        }

        function setFilteredAnrede() {
            if (BasisAngebotService.isPrivatPerson(vm.angebotModel.angebot, vm.fahrzeughalter)) {
                vm.filteredAnreden = MiscUtilsService.mergeUniq(MiscUtilsService.filterArray(SchluesselWerteUtilsService.getSchluesselwert('anreden'), ['Herr', 'Frau', 'Divers'], 'bezeichnung', true), _.get(vm.fahrzeughalter, 'anrede'), 'wert');
            }
        }
    }
})();
